// Template signature boxes are saved by signer ROLE (a template does not
// know who will sign); the shared placement screen works in signer
// positions, so the roles below are the "people" it offers, in order.

export const TEMPLATE_BOX_ROLES = [
  { role: 'client', name: 'Client' },
  { role: 'referral_attorney', name: 'Referral Attorney' },
  { role: 'handling_attorney', name: 'Attorney' },
];

const ESIGN_BOX_TYPES = new Set(['signature', 'initial', 'date', 'text', 'fullname']);

export const savedFieldsToBoxes = (fields) =>
  (fields || [])
    .filter((field) => ESIGN_BOX_TYPES.has(field.field_type) && field.is_active !== false)
    .map((field) => {
      const index = TEMPLATE_BOX_ROLES.findIndex(({ role }) => role === field.role);
      if (index < 0) return null;
      return {
        field_type: field.field_type,
        signer_position: index + 1,
        signer_email: '',
        page_number: Number(field.page_number) || 1,
        x: Number(field.x),
        y: Number(field.y),
        width: Number(field.width),
        height: Number(field.height),
      };
    })
    .filter(Boolean);

export const boxesToSavedFields = (boxes) =>
  (boxes || []).map((box, index) => ({
    role: TEMPLATE_BOX_ROLES[box.signer_position - 1]?.role || 'client',
    field_type: box.field_type,
    label: '',
    page_number: box.page_number,
    x: box.x,
    y: box.y,
    width: box.width,
    height: box.height,
    font_size: 1,
    required: true,
    hidden: true,
    order: index,
    is_active: true,
  }));
